import { useState } from 'react';

const allFloatingImages = [
  {
    src: 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/822512aed27761e0ffc3a6f5b6165479.jpeg',
    alt: 'Floral mandala wind spinner',
  },
  {
    src: 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/8d06bfc80ffb6612bf58ee5ce714cd6a.jpeg',
    alt: 'Hummingbird wind spinner',
  },
  {
    src: 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/838baca71cc420e75fb01f054705e7e0.jpeg',
    alt: 'Sunburst wind spinner',
  },
  {
    src: 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/8d06bfc80ffb6612bf58ee5ce714cd6a.jpeg',
    alt: 'Dragonfly wind spinner',
  },
  {
    src: 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/d0e41d3bc3e35a63898b39d5c5bb5cdb.jpeg',
    alt: 'Peacock wind spinner',
  },
  {
    src: 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/1670d5e19dedf3355b1628caad1293ab.jpeg',
    alt: 'Butterfly wind spinner',
  },
];

const cardPositions = [
  { rotation: '-14deg', top: '12%', right: '22%', zIndex: 1, delay: '0s' },
  { rotation: '2deg', top: '5%', right: '6%', zIndex: 3, delay: '1.2s' },
  { rotation: '16deg', top: '22%', right: '14%', zIndex: 2, delay: '0.6s' },
];

export default function HeroBanner() {
  const [offset, setOffset] = useState(0);

  const handleNext = () => {
    setOffset((prev) => (prev + 1) % allFloatingImages.length);
  };

  const visibleCards = [
    allFloatingImages[offset % allFloatingImages.length],
    allFloatingImages[(offset + 1) % allFloatingImages.length],
    allFloatingImages[(offset + 2) % allFloatingImages.length],
  ];

  return (
    <section className="relative min-h-[85vh] flex items-center overflow-hidden">
      <style>{`
        @keyframes hero-float {
          0%, 100% { transform: translateY(0) rotate(var(--r)); }
          50% { transform: translateY(-14px) rotate(var(--r)); }
        }
      `}</style>

      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/f935ad373ab11652985830cd18783d78.webp"
          alt="SpinWorld decorative background"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="container-main relative z-10 w-full">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-16">
          
          {/* Left: Text Content */}
          <div className="w-full lg:w-[55%] text-left py-12 lg:py-0">
            <h1 className="font-serif font-bold text-[#2c2a4a] text-4xl sm:text-5xl md:text-[56px] lg:text-[64px] leading-[1.35] mb-6 md:mb-8">
              One of the Largest<br />
              Selections of Wind<br />
              Spinners in the USA.
            </h1>
            
            <p className="text-[#2c2a4a]/80 font-sans text-sm md:text-base leading-relaxed max-w-md mb-8 md:mb-10">
              Discover over 70+ Designs offered, hand-painted and laser-cut wind spinners crafted from rustproof stainless steel.
            </p>

            <div className="flex flex-row items-center gap-3 md:gap-6">
            <a
              href="/shop"
              className="inline-block bg-[#4f528d] text-white font-sans font-semibold px-5 py-2.5 md:px-7 md:py-3 rounded-md text-sm md:text-base tracking-wide hover:bg-[#3d4070] transition-colors whitespace-nowrap shadow-lg"
            >
              Shop Now
            </a>

              {/* Happy Customers Social Proof */}
              <div className="flex items-center">
                {/* Avatar Stack */}
                <div className="flex -space-x-2">
                  <div className="w-7 h-7 md:w-10 md:h-10 rounded-full overflow-hidden border-2 border-[#2c2a4a]/20">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20smiling%20middle%20aged%20caucasian%20man%20with%20short%20brown%20hair%20wearing%20casual%20outdoor%20clothing%2C%20warm%20natural%20soft%20lighting%2C%20clean%20neutral%20beige%20background%2C%20happy%20friendly%20expression%2C%20customer%20testimonial%20style%20close%20up%20face&width=80&height=80&seq=avatar-man-1&orientation=squarish"
                      alt="Happy customer"
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="w-7 h-7 md:w-10 md:h-10 rounded-full overflow-hidden border-2 border-[#2c2a4a]/20">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20smiling%20young%20woman%20with%20blonde%20hair%20wearing%20casual%20summer%20clothing%2C%20warm%20natural%20soft%20lighting%2C%20clean%20neutral%20beige%20background%2C%20happy%20friendly%20expression%2C%20customer%20testimonial%20style%20close%20up%20face&width=80&height=80&seq=avatar-woman-1&orientation=squarish"
                      alt="Happy customer"
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="w-7 h-7 md:w-10 md:h-10 rounded-full overflow-hidden border-2 border-[#2c2a4a]/20">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20smiling%20elderly%20african%20american%20man%20with%20glasses%20wearing%20casual%20polo%20shirt%2C%20warm%20natural%20soft%20lighting%2C%20clean%20neutral%20beige%20background%2C%20happy%20friendly%20expression%2C%20customer%20testimonial%20style%20close%20up%20face&width=80&height=80&seq=avatar-man-2&orientation=squarish"
                      alt="Happy customer"
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>

                {/* Stars & Text */}
                <div className="flex flex-col ml-2 md:ml-3">
                  <div className="text-red-500 text-[10px] md:text-xs leading-none tracking-wider">
                    ★★★★★
                  </div>
                  <div className="text-[#2c2a4a]/90 text-[10px] md:text-sm font-bold leading-tight mt-0.5 whitespace-nowrap">
                    15k+ Happy Customers
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Floating Product Cards */}
          <div
            className="hidden lg:block relative w-[45%] h-[520px] cursor-pointer select-none"
            onClick={handleNext}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleNext();
              }
            }}
            aria-label="Click to see next products"
          >
            {visibleCards.map((card, i) => (
              <div
                key={`${i}-${offset}`}
                className="absolute w-[260px] xl:w-[300px]"
                style={{
                  top: cardPositions[i].top,
                  right: cardPositions[i].right,
                  zIndex: cardPositions[i].zIndex,
                  '--r': cardPositions[i].rotation,
                  animation: `hero-float 5s ease-in-out ${cardPositions[i].delay} infinite`,
                } as React.CSSProperties}
              >
                <div className="bg-white rounded-xl shadow-2xl p-2 overflow-hidden hover:scale-[1.02] transition-transform duration-300">
                  <img
                    src={card.src}
                    alt={card.alt}
                    className="w-full h-auto object-cover rounded-lg"
                    loading="eager"
                  />
                </div>
              </div>
            ))}

            {/* Click hint */}
            <div className="absolute bottom-2 right-6 bg-white/80 backdrop-blur-sm text-[#4f528d] text-xs font-semibold px-3 py-1.5 rounded-full shadow-sm pointer-events-none">
              Click to explore
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}